// Wrap fetch with a soft timeout. If a request takes longer than
// SERVER_TIMEOUT_MS, a SERVER_TIMEOUT_EVENT is dispatched so the registration
// workflow can show a "server down" notice — but the request is NOT aborted.
// If the server eventually responds, a SERVER_RECOVERED_EVENT is dispatched so
// the workflow can dismiss the notice and continue as normal.
//
// NOTE: only the registration workflow listens for these events. The
// email / mailing-list signup intentionally does not use this wrapper.

export const SERVER_TIMEOUT_MS = 45000; // 45s

export const SERVER_TIMEOUT_EVENT = 'calibrite:server-timeout';
export const SERVER_RECOVERED_EVENT = 'calibrite:server-recovered';

const emit = (name) => {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(name));
  }
};

/**
 * fetch() that signals a timeout after timeoutMs without cancelling the request.
 * @param {string} url
 * @param {Object} options - standard fetch options
 * @param {number} timeoutMs - timeout in milliseconds (default 45s)
 * @returns {Promise<Response>}
 */
export const fetchWithTimeout = async (url, options = {}, timeoutMs = SERVER_TIMEOUT_MS) => {
  let timedOut = false;
  const timer = setTimeout(() => {
    timedOut = true;
    emit(SERVER_TIMEOUT_EVENT);
  }, timeoutMs);

  try {
    const response = await fetch(url, options);
    // Server responded — if we'd already flagged a timeout, signal recovery.
    if (timedOut) emit(SERVER_RECOVERED_EVENT);
    return response;
  } finally {
    clearTimeout(timer);
  }
};

export default fetchWithTimeout;
